document.addEventListener("click", async (event) => {
  const button = event.target.closest(".featured-blog--load-more");
  if (!button) return;

  const label = button.querySelector("div");
  const blogHandle = button.dataset.blog;
  const nextPage = parseInt(button.dataset.page, 10) + 1;
  const grid = document.querySelector(".blog-grid--root");
  const perPage = 3;

  button.disabled = true;
  if (label) label.textContent = "Loading...";

  try {
    const response = await fetch(`/blogs/${blogHandle}?page=${nextPage}`);
    const html = await response.text();

    // Parse the entire next page's HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Grab *its own* grid and items
    const newGrid = doc.querySelector(".blog-grid--root");
    const newArticles = newGrid ? newGrid.querySelectorAll(".blog-grid--item") : [];

    if (newArticles.length > 0 && grid) {
      newArticles.forEach((article) => grid.appendChild(article));
      button.dataset.page = nextPage;

      // ✅ Check total pages from the fetched doc
      const totalPages = parseInt(newGrid?.dataset.totalPages || "999", 10);

      // If this was the last page (or fewer than perPage articles), remove button now
      if (nextPage >= totalPages || newArticles.length < perPage) {
        button.remove();
      } else {
        button.disabled = false;
        if (label) label.textContent = "View more";
      }
    } else {
      button.remove();
    }
  } catch (err) {
    console.error("Load more failed:", err);
    if (label) label.textContent = "View more";
    button.disabled = false;
  }
});
